export default __webpack_public_path__ + "static/intro_mob_md-eebab9509456fd8d0a7d7410bddf427e.png";